import { FACET_SORT_ENUM } from 'components/sortSelect';

/**
 * Helper utilities for getting application specific read only data to specific places in slykit
 *
 * MOTIVATION: I didn't want to prop drill a static string from the application to the timeline selector so I made this.
 *
 * MAINTENANCE: If we're wanting to have properties like this that need to be updated during runtime we should switch to
 * using a context and using selector hooks.
 *
 * EXAMPLE USAGE
 * // In application app.tsx
 * setReadOnlyOverride('defaultTemporalProperty', "Patent Status");
 * // In slykit
 * const test = getReadOnlyOverride('defaultTemporalProperty');
 */

// All properties should be optional and should only be set at initialization time. They can be read whenever
interface ReadOnlyOverrides {
	defaultTemporalProperty?: string;
	defaultFacetSortOrder?: {
		[propertyName in string]: FACET_SORT_ENUM;
	};
}

// This variable should be private
const overrides: ReadOnlyOverrides = {};

// Getter
export function getReadOnlyOverride<K extends keyof ReadOnlyOverrides, R = ReadOnlyOverrides[K]>(key: K) {
	return overrides[key];
}

// Setter
export function setReadOnlyOverride<K extends keyof ReadOnlyOverrides, V extends ReadOnlyOverrides[K]>(
	key: K,
	value: V
) {
	overrides[key] = value;
}
